import styled from 'styled-components';

export const ScrollContainer = styled.div`
   display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-y: auto;
  scrollbar-width: none;
`;

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom:15px;
  font-weight: 500;
  color: #323131;
`;

export const Text = styled.p`
  font-size: 16px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  margin: 25px 0;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom:15px;
`;

export const LastSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 40px;
`;

export const OfferContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: #F7F5F6;
  border-radius: 15px;
  gap: 16px;
  padding: 15px;
    width: 100%;
    max-width: 1200px;
`;

export const OfferQrCode = styled.div`
  position: absolute;
  left: calc(50% - 135px);
  height: 270px;
  width: 100%;
  max-width: 270px;
  border-radius: 15px;
  top: 30px;
  background-color: #FFF;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OfferImage = styled.img`
  width: 100%;
    height: 250px;
    @media (min-width: 768px) {
        height: 300px;
    }
    @media (min-width: 1024px) {
        height: 400px;
    }
  object-fit: cover;
  border-radius: 10px;
`;

export const OfferTitle = styled.span`
  font-size: 18px;
  line-height: 1.5;
  font-weight: 500;
  color: #323131;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: #F4F4F5;
  border-radius: 15px;
  gap: 16px;
  width:100%;
  flex-wrap: wrap;
`;

export const QrCodeButton = styled.div`
  background-color: #FFF;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  padding: 15px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OfferModalButton = styled.div`
  background-color: #1c1c1c;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  padding: 15px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex: 1;
  max-width: 100%;
`;

export const OfferModalButtonTitle = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #FFF;
  min-width: 200px;
  width: 100%;
`;

export const GalleryContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-top: 25px;
    @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

export const GalleryItem = styled.img`
   width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
  cursor:pointer;
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
`;
